import { createFileRoute } from "@tanstack/react-router";
import { NicknameForm } from "@/components/onboarding/nickname-form";
import { OnboardingLayout } from "@/components/onboarding/onboarding-layout";

export const Route = createFileRoute("/onboarding/apelido")({
	component: OnboardingStep1,
});

function OnboardingStep1() {
	return (
		<OnboardingLayout>
			<NicknameForm />
		</OnboardingLayout>
	);
}
